import React from "react";
import "./Footer.css"

const Footer = () => {
    return(
        <div className='footer pt-3 pb-2'>
            <div className='container'>
                <ul>
                    <li><a href="/">V3 Careers</a></li>
                    <li><a href="/jobs">Jobs</a></li>
                </ul>
            </div>
        </div>
    );
};

export default Footer;